  <template>
    <div class="cat_product-carousel" :style="{ padding }">
      <div class="container" :class="catlocation" >
        <div class="cat_product__heading">
          <h2 v-if="headingData" class="cat_product__heading-title">{{ headingData }}</h2>
          <div v-if="descData" class="cat_product__heading-description">
            <p v-html="replaceCustom(htmlSpecialcharsDecode(descData))"></p>
          </div>
        </div>
        <div class="cat_product-slide"
        v-if="!loading && itemData"
        :class="{ 'center-items': itemData && itemData.length <= 4 }"
        >
          <swiper
            class="cat_product-swiper"
            v-if="itemData"
            :modules="[Navigation, Pagination, FreeMode ]"
            :spaceBetween="10"
            :slidesPerView="2.2"
            :free-mode="true"
            :navigation="{
                nextEl: '.slider-nav #next',
                prevEl: '.slider-nav #prev',
            }"
            :pagination="false"
            :breakpoints="{
              991: { slidesPerView: 5 },
              767: { slidesPerView: 2.2 }
            }"
          >
            <swiper-slide v-for="(item, index) in itemData" :key="index" class="coll-slider-item">
              <div class="sb-cats__item-details" v-if="item.category_img_medium">
                <a :href="getLangUrl(item.category_url, baseUrl, locale)" rel="noopener noreferrer" class="sb-cats__item-url">
                  <img
                    v-if="item.category_img_medium"
                    :alt="item.category_img_alt"
                    width="322" height="322"
                    class="alt-lazy-img sb-cats__item-thumbnail img_detail"
                    :data-original_src="item.category_img_full"
                    :src="item.category_img_medium"
                  />
                  <span class="sb-cats__item-title">{{ item.category_title }}</span>
                </a>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="slider-nav" v-if="!loading">
            <button id="prev" >
              <svg
                fill="#000000"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                transform="rotate(180)"
              >
                <polyline
                  points="7.5 3 16.5 12 7.5 21"
                  style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-width: 0.816px;"
                />
              </svg>
            </button>
            <button id="next" >
              <svg
                fill="#000000"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
              >
                <polyline
                  points="7.5 3 16.5 12 7.5 21"
                  style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-width: 0.816px;"
                />
              </svg>
            </button>
          </div>
      </div>
    </div>
  </template>
  
  <script lang="ts" setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue';
    import { Swiper, SwiperSlide } from "swiper/vue";
    import { Navigation, Pagination, FreeMode } from "swiper/modules";
    import "swiper/css";
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const wooStore = useWooStore();
    const countryShort = wooStore.country?.country_short;
  interface Item {
    link: string;
    image: string;
    title: string;
  }
  type Location = 'category' | 'collection' | 'sale';
  const { $file, $ajax } = useNuxtApp();
  const pgData = ref();
  const userStore = useUserStore();
  const data = ref();
  const headingData = ref<string | null>(null);
  const descData = ref<string | null>(null);
  const itemData = ref<any[]>([]);
  const loading = ref(true);
  import { useI18n } from 'vue-i18n';
  const { locale } = useI18n();
  import { getLangUrl } from '~/utils/getLangUrl';
  interface ICatResponse {
    success: boolean;
    data: string;
  }
  const props = defineProps({
    padding: {
      type: String,
      default: '0', // Default padding
    },
    catlocation: {
      type: String as PropType<Location>,
      required: true,
      default: 'sale',
    },
  });
  const replaceCustom = (data:any) => {
    return htmlSpecialcharsDecode(data)
      .replace(/<p>/g, '<span>')
      .replace(/<\/p>/g, '</span>');
  }

  const get_page_data = async () => {
    try {
      // const response = await $ajax.get<IHomeResponse>('campaign/campaign-category.json');
        const { data: response } = await useAsyncData(
            'data',
            async () => {
              return $ajax.get<ICatResponse>('data/campaign/campaign-category.json', {
                headers: {
                  Authorization: `Bearer ${userStore.csrf}`,
                  'X-API-Server': userStore.csrf_server
                },
              });
            },
            { immediate: true, watch: [], onError: console.error }
          );

        if (response.value && response.value.success) {
          const responseData = response.value.data;
          pgData.value = typeof responseData === 'object' ? responseData : JSON.parse(responseData);
        // if (pgData.value.shop_by_cat) {
        //     data.value = pgData.value.shop_by_cat;
        // }
        if (pgData.value.shop_by_cat) {
          const apiData = pgData.value.shop_by_cat;
          // console.log('Category data tee: ' , props.catlocation);
          if (props.catlocation === 'category') {
            headingData.value = apiData.heading ?? '';
            descData.value = apiData.description ?? '';
            itemData.value = apiData.cat_items ?? '';
          } else if (props.catlocation === 'collection') {
            headingData.value = apiData.cat_heading_collection ?? '';
            descData.value = apiData.cat_desc_collection ?? '';
            itemData.value = apiData.col_items ?? '';
          } else if (props.catlocation === 'sale') {
            headingData.value = apiData.category_heading_sale ?? '';
            descData.value = apiData.cat_desc_sale ?? '';
            itemData.value = apiData.sale_items ?? '';
          }
        }

      } else {
        console.error("Invalid or empty response:", response.value);
      }
    } catch (error) {
      console.error("Error fetching campaign data:", error);
    } finally {
      loading.value = false; // Data has finished loading
    }
  };
  get_page_data();
  
  const options = ref({
    itemsToShow: { desktop: 4.5, tablet: 2, mobile: 1 },
    itemsToScroll: 1,
    breakpoints: { tablet: 991, mobile: 767 },
  });
  
  onMounted(() => {
    get_page_data();
  });
  
  </script>
  
  <style lang="scss" >
    @import "@/assets/scss/components/sale-campaign/_category-carousel.scss";
  </style>
  